import { render, staticRenderFns } from "./VisitedPlaces.vue?vue&type=template&id=d5617c48&scoped=true"
import script from "./VisitedPlaces.vue?vue&type=script&lang=js"
export * from "./VisitedPlaces.vue?vue&type=script&lang=js"
import style0 from "./VisitedPlaces.vue?vue&type=style&index=0&id=d5617c48&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5617c48",
  null
  
)

export default component.exports